import Vue, { DirectiveOptions } from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/css/all.min.css'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router/router'
import '@/icons/components'
import '@/permission'
import '@/utils/globalComponents'
import '@/utils/component-hook'
import * as filters from '@/filters' // filters: Modules对象
import * as directives from '@/directives'
import { checkSrc, onLoad } from '@/utils/fix'
import { openWindow } from '@/utils/global-methods'
// import VideoPlayer from 'vue-video-player'

Vue.use(ElementUI)
// Vue.use(VideoPlayer)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

Vue.prototype.checkSrc = checkSrc
Vue.prototype.onLoad = onLoad
Vue.prototype.openWindow = openWindow

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key])
})

// Register global directives
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
